import { atomFamily } from "jotai/utils";

import { InsuranceType } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionInsuranceTypeToActivateAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`insuranceTypeToActivate-${sessionId}`, null as InsuranceType | null)
);
export const insuranceTypeToActivateAtom = createDerivedSessionAtom<InsuranceType | null>(
  sessionInsuranceTypeToActivateAtom
);
